import { FC, useCallback } from 'react'
import styles from 'components/features/pfm/DebugPage/DebugPage.styl'
import ModuleWrapper2020 from 'components/features/pfm/ModuleWrapper2020/ModuleWrapper2020'
import Button from 'components/features/pfm/Button/Button'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import { consoleRelay } from 'components/features/webSocketLogger/ConsoleWSRelay'

type DebugPageProps = {

}

const DebugPage: FC<DebugPageProps> = () => {

  const handleStartLogging = useCallback(() => {
    consoleRelay.startPermanent()
  }, [])

  return (
    <div className={ styles.root }>
      <div className={ styles.content }>
        <ModuleWrapper2020
          title='Debug page'
          forceRoundedCorners
        >
          <NavigationLink to='home'>
            <Button theme='danger' fullWidth>
              Back to Status
            </Button>
          </NavigationLink>
        </ModuleWrapper2020>
        <br /><br />
        <ModuleWrapper2020
          title='Logs control'
          forceRoundedCorners
        >
          <NavigationLink to='home'>
            <Button onClick={ handleStartLogging } fullWidth>Start</Button>
          </NavigationLink>
        </ModuleWrapper2020>
      </div>
    </div>
  )
}

export default DebugPage
